export const callExportKnowledgeBase = async (
  locationId: string
): Promise<iResponse<void>> => {
  const token = localStorage.getItem('token');
  const url = `${process.env.REACT_APP_API_BASE}/zazu/knowledge/location/${locationId}/export`;

  const fetchOptions: RequestInit = {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    },
    method: 'GET'
  };

  const request: Response = await fetch(url, fetchOptions);

  if (request.status >= 400) {
    let errorBody: ResponseErrorObj | undefined;
    try {
      errorBody = (await request.json()) as ResponseErrorObj;
    } catch {
      errorBody = undefined;
    }
    return { code: request.status, error: errorBody };
  }

  const blob = await request.blob();
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = `knowledge-base-${locationId}.csv`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(objectUrl);

  return { code: request.status };
};

export default callExportKnowledgeBase;
